import clsx from 'clsx'
import { Alert } from 'gu-ui-kit'
import PropTypes from 'prop-types'
import React, { useCallback, useLayoutEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch } from 'react-redux'
import styles from 'modules/Notifications/notifications.module.scss'
import { notificationRemove, notificationRemoveAfterDelay } from 'modules/Notifications/actions'

const Index = ({ UUID, type, message, delay = 5000 }) => {
  let timeout = null
  const { t } = useTranslation()
  const dispatch = useDispatch()

  const [visible, setVisible] = useState(false)

  useLayoutEffect(() => {
    setVisible(true)

    timeout = setTimeout(() => {
      setVisible(false)
      removeItem()
      clearTimeout(timeout)
    }, delay)

    return () => {
      clearTimeout(timeout)
    }
  }, [])

  const removeItem = useCallback(() => dispatch(notificationRemoveAfterDelay({ UUID, delay })), [])

  const closeNotification = useCallback((UUID) => {
    dispatch(notificationRemove({ UUID }))
  }, [])

  return (
    <Alert
      className={clsx(styles['notifications__item'], {
        [styles['notifications__item_visible']]: !!visible,
      })}
      key={'notification-' + UUID}
      severity={type}
      onClose={() => closeNotification(UUID)}
    >
      {typeof message === 'string' ? (
        <div
          dangerouslySetInnerHTML={{
            __html: t(message),
          }}
        />
      ) : (
        message
      )}
    </Alert>
  )
}

Index.propTypes = {
  UUID: PropTypes.string,
  type: PropTypes.oneOf(['error', 'warning', 'info', 'success']),
  message: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  delay: PropTypes.number,
}

export default Index
